<template>
  <div class="form-group" :class="{ required: isRequired }">
    <label v-if="label" class="form-label">{{ label }} <sup v-if="asterisk">1</sup></label>
    <div class="form-control-group">
      <slot></slot>
      <span v-show="isInvalid" data-testid="span-notification-error" class="form-group-error text-danger">
        {{ errorMessage }}
      </span>
      <div v-if="asterisk" class="text-muted form-description"><sup>1</sup> {{ asterisk }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormGroup',
  props: {
    label: {
      type: String,
      required: false
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Object,
      required: false
    },
    messages: {
      type: Object,
      required: false
    },
    asterisk: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      localMessages: {
        required: this.$t('errorMessage.required'),
        allowSymbols: this.$t('errorMessage.allowSymbols'),
        likePhone: this.$t('errorMessage.likePhone'),
        phoneOverlong: this.$t('errorMessage.phoneOverlong'),
        numeric: this.$t('errorMessage.numeric'),
        minValue: this.$t('errorMessage.minValue')
      }
    }
  },
  mounted() {
    if (this.messages) {
      this.localMessages = Object.assign({}, this.localMessages, this.messages)
    }
  },
  computed: {
    errorMessage() {
      if (!this.errors) {
        return ''
      }

      let msg = []
      // eslint-disable-next-line no-unused-vars
      for (let key in this.errors) {
        if (this.errors[key] === true) {
          msg.push(this.getMessage(key))
        }
      }

      return msg.join('; ')
    },
    isRequired() {
      return this.errors && typeof this.errors.required !== 'undefined'
    }
  },
  methods: {
    getMessage(key) {
      if (Object.prototype.hasOwnProperty.call(this.localMessages, key)) {
        return this.localMessages[key]
      }

      return this.$t('errorMessage.incorrectly')
    }
  }
}
</script>
